// Убирает висячие предлоги/союзы — ставит неразрывный пробел после них,
// чтобы они не оставались одни в конце строки при переносе.
const PREPOSITIONS =
  "и|а|но|да|или|как|что|чтобы|в|во|с|со|к|ко|у|о|об|обо|на|за|из|изо|от|ото|до|по|под|подо|над|надо|при|для|без|безо|через|про|не|ни|ли|же|бы|то|так|уж";
const HANGING_WORD_RE = new RegExp(`(^|\\s)(${PREPOSITIONS})\\s`, "giu");
const NBSP = String.fromCharCode(160);
// В части текстов из CMS (похоже, вставлены из другого редактора) внутри
// строки затесались символы-разделители строк (Unicode line/paragraph
// separator) — браузер переносит по ним принудительно, независимо от
// ширины блока и неразрывных пробелов. Собираем паттерн через charCode,
// чтобы в исходнике не было "сырых" спецсимволов.
const LINE_SEPARATORS_RE = new RegExp(
  `[${String.fromCharCode(8232)}${String.fromCharCode(8233)}]`,
  "g"
);

export function noWidow(text) {
  if (!text) return text;
  const clean = text.replace(LINE_SEPARATORS_RE, " ");
  return clean.replace(HANGING_WORD_RE, (match, before, word) => `${before}${word}${NBSP}`);
}
